import axios from 'axios'

export default {
    get: () => axios.get('suppliers'),
    store: (data) => axios.post('suppliers/store', data),
    update: (data) => axios.post('suppliers/update', data),
    delete: (id) => axios.post('suppliers/delete', id),
    excel: () => axios.post('suppliers/excel')
}